import { render, staticRenderFns } from "./ShoppingCartItem.vue?vue&type=template&id=96b90cb6&scoped=true"
import script from "./ShoppingCartItem.vue?vue&type=script&lang=js"
export * from "./ShoppingCartItem.vue?vue&type=script&lang=js"
import style0 from "./ShoppingCartItem.vue?vue&type=style&index=0&id=96b90cb6&prod&lang=scss&scoped=true"
import style1 from "./ShoppingCartItem.vue?vue&type=style&index=1&id=96b90cb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b90cb6",
  null
  
)

export default component.exports